import { Injectable } from '@angular/core';
import { Product } from 'src/app/models/verylys';

@Injectable({
    providedIn: 'root'
})

export class SearchProductService {
    constructor() {

    }

    /*
     * Get the product index on search bar
     *
     * @productList     array contain the product list
     *                  this var will be remove when we had a product service to get the list from the API
     * @search          search bar text
    */
    public searchProduct(products: Product[], search: string): Product[] {
        if (search == null || search == "" || search == " ") {
            return null;
        }

        return products.filter((product: Product) => this.searchMatchName(search, product.name));
    }

    /*
     * Return if a search match with the name
     *
     * search   search text
     * name     name product
     * 
     * return   true|false
    */
    private searchMatchName(search: string, name: string): boolean {
        // Characters to replace or remove from the search string
        let replace: Array<string> = ['\'', ':', '-', '/', '\\', '"', ' ', '\'']

        // If either search or name is empty, return false
        if (!name || !search) {
            return false;
        }

        // Convert both search and name to uppercase for case-insensitive comparison
        name = name.toUpperCase();
        search = search.toUpperCase();

        // Replace special characters in the search string
        for (let index in replace) {
            search = search.replace(replace[index], "");
        }

        // If the name contains the search string exactly, return true
        if (name.includes(search)) {
            return true;
        }

        // Check if search is a substring of name
        if (name.indexOf(search) !== -1) {
            return true;
        }

        // Check if product name contains search letters in sequence
        let searchIndex = 0;
        for (let i = 0; i < name.length; i++) {
            if (name[i] === search[searchIndex]) {
                searchIndex++;
                if (searchIndex === search.length) {
                    return true;
                }
            }
        }

        // If none of the above conditions are met, return false
        return false;
    }
}
